import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductGroupListDTO extends TeamAccessDTO {

    id: string;

    name: string;

    description: string;

}
